/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
import { useRouter } from "next/router"
import { useState } from "react"
import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import OurCommitmentSustanModal from "@components/pages/our-commitment/our-commitment-sustain-modal"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import SwiperNavigation from "../SwiperNavigation"

export default function SectionHalSlider({
  sectionName,
  data,
  reports = [],
  loadingReports,
  errorReports,
}) {
  const [trigger, anim] = useScrollAnim()
  const [swipePage, setSwipePage] = useState(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const router = useRouter()
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const [showModal, setShowModal] = useState(false)

  return (
    <section className={`sc-half-slider ${sectionName}`} ref={trigger}>
      {sectionName === "sc-our-commitment-sustain" && reports?.length ? (
        <OurCommitmentSustanModal
          showModal={showModal}
          setShowModal={setShowModal}
          locale={router.locale}
          reports={reports}
          loading={loadingReports}
          error={errorReports}
        />
      ) : null}
      <div className="container py-main">
        <div className="row">
          <div className="col-md-6 col-img">
            <SliderSwiper
              swiperRef={swiperRef}
              slidesPerView={1}
              breakpoints={null}
              spaceBetween={10}
              onSwiper={setSwipePage}
              onSlideChange={(slide) => {
                setCurrentSlide(slide?.realIndex)
              }}
              effect="fade"
              loop
            >
              {data?.map((item, i) => (
                <SwiperSlide key={`${sectionName}-${i}`}>
                  <Card img={item.img} imgRatio="r-4-3" variant="overlay">
                    {data?.length > 1 ? (
                      <div className="wrapper-footer">
                        <div className="wrapper-pagination">
                          <div className="pagination-swiper-list">
                            {data?.map((_, j) => (
                              <div
                                className={`pagination-swiper-item ${
                                  j === currentSlide
                                    ? "pagination-swiper-item-active"
                                    : ""
                                }`}
                                key={`pagination-item-${j}`}
                                onClick={() => {
                                  swipePage?.slideTo(j)
                                }}
                                role="button"
                                tabIndex={0}
                              />
                            ))}
                          </div>
                        </div>
                        <SwiperNavigation
                          handleNext={handleNext}
                          handlePrev={handlePrev}
                        />
                      </div>
                    ) : null}
                  </Card>
                </SwiperSlide>
              ))}
            </SliderSwiper>
          </div>
          <div className="col-md-6 col-text">
            {data?.map((item, i) => (
              <div
                className={`wrapper-text ${currentSlide === i ? "active" : ""}`}
                key={i}
              >
                <p className="label">{item.label}</p>
                <h4 className="title">{item.title}</h4>
                <div className="text">{item.text}</div>
                <div className="d-flex">
                  {item.link ? (
                    <div
                      onClick={() => router.push(item.link)}
                      className="link-sustain"
                      role="button"
                      tabIndex={0}
                    >
                      {item.linkText ??
                        translations[`learn_more_${router.locale}`]}{" "}
                      <span className="air ai-arrow-right" />
                    </div>
                  ) : null}
                  {sectionName === "sc-our-commitment-sustain" &&
                  reports?.length ? (
                    <div
                      onClick={() => {
                        document.body.classList.add("no-scroll")
                        setShowModal(true)
                      }}
                      className="link-sustain ml-3 ml-md-5"
                      role="button"
                      tabIndex={0}
                    >
                      {translations[`download_report_${router.locale}`]}
                      <span className="air ai-arrow-right" />
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
